var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import _ from "lodash";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export var ValidationResultType;
(function (ValidationResultType) {
    ValidationResultType["Note"] = "note";
    ValidationResultType["Error"] = "error";
    ValidationResultType["Warn"] = "warn";
})(ValidationResultType || (ValidationResultType = {}));
var CertificateValidator = /** @class */ (function () {
    function CertificateValidator() {
    }
    CertificateValidator.prototype.check_duplicates = function (pet, field, store, text, url) {
        if (field) {
            if (!store[field]) {
                store[field] = {
                    multiple: false,
                    message: "".concat(text, " ").concat(field, " is used for pet ").concat(pet.species, " ").concat(pet.name),
                    url: url,
                };
            }
            else {
                store[field] = {
                    multiple: true,
                    message: store[field]['message'] + " and pet ".concat(pet.species, " ").concat(pet.name),
                    url: url,
                };
            }
        }
    };
    CertificateValidator.prototype.process_duplicate = function (certificate, results, store) {
        for (var prop in store) {
            if (store[prop]['multiple']) {
                results.results['duplicate_' + prop] = {
                    type: ValidationResultType.Error,
                    message: store[prop]['message'],
                    url: store[prop]['url'],
                };
            }
        }
    };
    CertificateValidator.prototype.validate = function (team, branch, certificate, breeds) {
        var _this = this;
        var _a, _b, _c, _d;
        var route = useRoute(Ziggy);
        var result = {
            errorCount: 0,
            noteCount: 0,
            warnCount: 0,
            results: {},
        };
        result.results['client_checklist'] = {
            type: ValidationResultType.Warn,
            message: _jsxs("div", { children: ["The APHA require you to provide a checklist for bringing a pet back to the UK along with the AHC. You can download the checklist ", _jsx("a", __assign({ target: "_blank", href: "https://www.improve-ov.com/instructions/instructions-file.php?unique_id=677f9ffdd9d0f&file_type=Form&action=download", className: "underline" }, { children: "here" }))] }),
            url: null,
        };
        if (!((_b = (_a = certificate.branch) === null || _a === void 0 ? void 0 : _a.address_data) === null || _b === void 0 ? void 0 : _b.line_1)) {
            result.results['branch_address'] = {
                type: ValidationResultType.Error,
                message: 'Branch address is required.',
                url: route('team.branch.show', {
                    team: team,
                    branch: branch
                }),
            };
        }
        if (!((_c = certificate.branch) === null || _c === void 0 ? void 0 : _c.telephone)) {
            result.results['branch_telephone'] = {
                type: ValidationResultType.Error,
                message: 'Branch telephone number is required.',
                url: route('team.branch.show', {
                    team: team,
                    branch: branch
                }),
            };
        }
        if (certificate.first_country === null) {
            result.results['first_country'] = {
                type: ValidationResultType.Error,
                message: 'Country of entry is required.',
                url: route('team.branch.certificate.travel-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        if (certificate.client === null) {
            result.results['client'] = {
                type: ValidationResultType.Error,
                message: 'Owner details are required',
                url: route('team.branch.certificate.client-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        if (certificate.vet === null) {
            result.results['vet'] = {
                type: ValidationResultType.Error,
                message: 'Vet details are required',
                url: route('team.branch.certificate.vet-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        //  You can download our version at the end of this form.
        if (certificate.transporter === 'agent' || certificate.transporter === 'carrier') {
            result.results['transporter_letter'] = {
                type: ValidationResultType.Note,
                message: 'If the owner is not travelling with the pets, a letter of authorisation must be provided for the person travelling with the pet.',
                url: null,
            };
        }
        if (certificate.transporter === 'agent') {
            if (certificate.transporter_agent_name === null) {
                result.results['transporter_agent_name'] = {
                    type: ValidationResultType.Error,
                    message: 'Authorised person name is required',
                    url: route('team.branch.certificate.travel-step', {
                        team: team,
                        branch: branch,
                        certificate: certificate
                    }),
                };
            }
        }
        if (certificate.transporter === 'carrier') {
            if (certificate.transporter_carrier_company === null) {
                result.results['transporter_carrier_company'] = {
                    type: ValidationResultType.Error,
                    message: 'Transporting carrier company name is required',
                    url: route('team.branch.certificate.travel-step', {
                        team: team,
                        branch: branch,
                        certificate: certificate
                    }),
                };
            }
            // if (certificate.transporter_agent_name === null) {
            //     result.results['transporter_agent_name'] = {
            //         type: ValidationResultType.Error,
            //         message: 'Transporting carrier agent name is required.',
            //         url: route('team.branch.certificate.travel-step', {
            //             team: team,
            //             branch: branch,
            //             certificate: certificate
            //         }),
            //     }
            // }
        }
        //travel details
        if (certificate.date_of_entry === null) {
            result.results['date_of_entry'] = {
                type: ValidationResultType.Error,
                message: 'Date of entry is required',
                url: route('team.branch.certificate.travel-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }) + "#date_of_entry",
            };
        }
        //technically final country is not required, so just use it if it was filled in
        if (certificate.final_country && certificate.final_country.name === "Non-EU country") {
            result.results['final_country'] = {
                type: ValidationResultType.Note,
                message: _jsxs("div", { children: ["Additional forms will be required to enter a non-EU country and to return to the UK. For more information visit ", _jsx("a", __assign({ target: "_blank", href: "https://www.gov.uk/bring-pet-to-great-britain", className: "underline" }, { children: "https://www.gov.uk/bring-pet-to-great-britain" }))] }),
                url: null,
            };
        }
        if (certificate.return_in_120d === false) {
            result.results['return_in_120d'] = {
                type: ValidationResultType.Note,
                message: _jsxs("div", { children: ["An additional form will be required to re-enter the UK after 120 days - the form can be found here: ", _jsx("a", __assign({ target: "_blank", href: "https://www.gov.uk/bring-pet-to-great-britain", className: "underline" }, { children: "https://www.gov.uk/bring-pet-to-great-britain" }))] }),
                url: null,
            };
        }
        if (certificate.mode_of_travel === 'air') {
            result.results['mode_of_travel'] = {
                type: ValidationResultType.Note,
                message: 'A fit-to-fly certificate may be required. Please check with the airline for details.',
                url: null,
            };
        }
        if (certificate.certificate_pets.length === 0) {
            result.results['pets'] = {
                type: ValidationResultType.Error,
                message: 'At least one pet is required',
                url: route('team.branch.certificate.pet-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        else if (certificate.certificate_pets.length > 5) {
            result.results['pets'] = {
                type: ValidationResultType.Error,
                message: 'An AHC is not valid for more than 5 pets. There are exceptions for pets travelling to shows/exhibitions but we do not currently support this. Let us know if you would like to see this feature.',
                url: route('team.branch.certificate.pet-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        var duplicate = {};
        certificate.certificate_pets.forEach(function (certificatePet, idx) {
            var _a, _b;
            var pet = certificatePet.pet;
            _this.check_duplicates(certificatePet.pet, certificatePet.pet.transponder_num, duplicate, 'Transponder number', route('team.branch.certificate.vaccination-step', {
                team: team,
                branch: branch,
                certificate: certificate
            }));
            //banned breeds
            if (breeds) {
                var breed = _.find(_.filter(breeds, { species: pet.species }), { label: (_a = pet.breed) === null || _a === void 0 ? void 0 : _a.label });
                if (breed === null || breed === void 0 ? void 0 : breed.banned) {
                    result.results['banned.' + idx] = {
                        type: ValidationResultType.Warn,
                        message: "Breed ".concat((_b = pet.breed) === null || _b === void 0 ? void 0 : _b.label, " ").concat(pet.name ? "for " + pet.name : "", " may be banned in EU countries, or require proof of breed when travelling, or not be allowed to travel on an AHC, check with each destination country."),
                        url: null,
                    };
                }
            }
            //console.log(">result", result)
            //pet validations
            if (pet.date_of_birth && certificate.date_of_entry && certificate.first_country) {
                var dobPlusFifteenWeeks = moment(pet.date_of_birth).add(15, 'week');
                var firstEntry = moment(certificate.date_of_entry);
                if (dobPlusFifteenWeeks.isAfter(firstEntry, 'day')) {
                    if (['Czech Republic', 'Austria', 'Denmark'].includes(certificate.first_country.name)) {
                        result.results['date_of_birth.' + idx] = {
                            type: ValidationResultType.Error,
                            message: "Pet ".concat(pet.species, " ").concat(pet.name ? pet.name : "", " cannot travel at less than 15 weeks old. ").concat(certificate.first_country.name, " may accept unvaccinated pets <12 weeks old with a declaration that they have not been in contact with any wild species susceptible to rabies however we do not currently support this option. Please note they would need to be >15 weeks old with a valid Rabies vaccination on their return to Great Britain.  Dogs and cats under eight weeks of age cannot travel unless accompanied by their mother."),
                            url: route('team.branch.certificate.pet-step', {
                                team: team,
                                branch: branch,
                                certificate: certificate
                            }),
                        };
                    }
                    else {
                        result.results['date_of_birth.' + idx] = {
                            type: ValidationResultType.Error,
                            message: "Pet ".concat(pet.species, " ").concat(pet.name ? pet.name : "", " cannot travel at less than 15 weeks old."),
                            url: route('team.branch.certificate.pet-step', {
                                team: team,
                                branch: branch,
                                certificate: certificate
                            }),
                        };
                    }
                }
            }
            // Echinococcus required
            if ((certificatePet.is_echinococcus_required || certificate.echinococcus_override)) {
                if (certificatePet.echinococcus_vaccination_date) {
                    // Echinococcus treatment date should be 1-5 days before travel
                    if (certificate.date_of_entry) {
                        var date = moment(certificatePet.echinococcus_vaccination_date);
                        var fiveDaysBefore = moment(certificate.date_of_entry).subtract(5, 'days');
                        var firstEntry = moment(certificate.date_of_entry);
                        if (date.isBefore(fiveDaysBefore, 'day') ||
                            //if this is an override allow them to administer up to the last day.
                            (!certificate.echinococcus_override ? date.isSameOrAfter(firstEntry, 'day') : date.isAfter(firstEntry, 'day'))) {
                            var echi_date_limit = moment(certificate.date_of_entry).format('DD/MM/YYYY');
                            if (certificate.echinococcus_override) {
                                echi_date_limit = 'entry into the country requiring the treatment.';
                            }
                            result.results['echinococcus_vaccination_date.' + idx] = {
                                type: certificate.skip_deworming ? ValidationResultType.Warn : ValidationResultType.Error,
                                message: _jsxs("div", { children: ["Tapeworm treatment for ", pet.name, " must be ", _jsx("strong", { children: "24-120h" }), " before ", echi_date_limit] }),
                                url: certificate.skip_deworming ? null : route('team.branch.certificate.vaccination-step', {
                                    team: team,
                                    branch: branch,
                                    certificate: certificate
                                }),
                            };
                        }
                        else if (date.isAfter(moment(), 'day')) {
                            //if treatment date is after today, remind the vet to book the appointment
                            result.results['echinococcus_vaccination_date.' + idx] = {
                                type: ValidationResultType.Note,
                                message: "Don't forget to book tapeworm treatment for ".concat(pet.name, " on ").concat(date.format('DD/MM/YYYY')),
                                url: null,
                            };
                        }
                        if (certificate.echinococcus_override) {
                            result.results['echinococcus_vaccination_date_override.' + idx] = {
                                type: ValidationResultType.Warn,
                                message: _jsxs("div", { children: ["NB: You have scheduled an optional tapeworm treatment for ", _jsx("strong", { children: pet.name }), " on ", date.format('DD/MM/YYYY'), ". Please ensure this is ", _jsx("strong", { children: "24-120h" }), " before entry to the destination country that requires treatment."] }),
                                url: null,
                            };
                        }
                    }
                }
                else {
                    //if date is missing log the error
                    result.results['echinococcus_required_before_travel.' + idx] = {
                        type: ValidationResultType.Warn,
                        message: "Tapeworm treatment date is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                //echinococcus treatment manufacturer is required
                if (!certificatePet.echinococcus_vaccine_manufacturer) {
                    result.results['echinococcus_vaccine_manufacturer.' + idx] = {
                        type: ValidationResultType.Warn,
                        message: "Name of tapeworm treatment manufacturer is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                else if (certificatePet.echinococcus_vaccine_manufacturer === 'other' &&
                    !certificatePet.echinococcus_vaccine_manufacturer_other) {
                    result.results['echinococcus_vaccine_manufacturer.' + idx] = {
                        type: ValidationResultType.Warn,
                        message: "Name of tapeworm treatment manufacturer is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                // Administering vet is required
                if (!certificatePet.echinococcus_vet) {
                    result.results['echinococcus_vet.' + idx] = {
                        type: ValidationResultType.Warn,
                        message: "Tapeworm treatment administering vet is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
            }
            else {
                //not required - remind the client they need to arrange treatment before returning (for dogs)
                if (pet.species === 'dog') {
                    result.results['echinococcus_required_before_travel.' + idx] = {
                        type: ValidationResultType.Note,
                        message: _jsxs("div", { children: ["Tapeworm treatment will be required ", pet.name ? "for " + pet.name : "", " ", _jsx("strong", { children: "before returning to the UK" })] }),
                        url: null,
                    };
                }
            }
            if (certificatePet) {
                // Rabies validations
                if (certificatePet.rabies_vaccination_booster === null) {
                    result.results['rabies_vaccination_booster.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination type is required ".concat(pet.name ? "for " + pet.name : ""),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                else {
                    if (certificatePet.rabies_vaccination_date && certificate.date_of_entry) {
                        var twentyoneDaysAfter = moment(certificatePet.rabies_vaccination_date).add(21, 'days');
                        var firstEntry = moment(certificate.date_of_entry);
                        if (twentyoneDaysAfter.isSameOrAfter(firstEntry) &&
                            (certificatePet.rabies_vaccination_booster === "booster_before_expiry" ||
                                certificatePet.rabies_vaccination_booster === "booster_after_expiry")) {
                            result.results['rabies_vaccination_booster.' + idx] = {
                                type: ValidationResultType.Warn,
                                message: "Pet ".concat(pet.name, " is travelling within 21 days of a rabies vaccination booster. Make sure you have included evidence of the previous vaccination in the supporting documentation."),
                                url: route('team.branch.certificate.document-step', {
                                    team: team,
                                    branch: branch,
                                    certificate: certificate
                                }),
                            };
                        }
                    }
                }
                if (certificatePet.rabies_vaccine_manufacturer === null) {
                    result.results['rabies_vaccine_manufacturer.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination manufacturer is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                else if (certificatePet.rabies_vaccine_manufacturer === 'other' &&
                    !certificatePet.rabies_vaccine_manufacturer_other) {
                    result.results['rabies_vaccine_manufacturer.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination manufacturer is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                if (certificatePet.rabies_vaccine_batch_number === null) {
                    result.results['rabies_vaccine_batch_number.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination batch number is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                if (certificatePet.rabies_vaccine_valid_from) {
                    var validFrom = moment(certificatePet.rabies_vaccine_valid_from);
                    var firstEntry = moment(certificate.date_of_entry);
                    if (validFrom.isAfter(firstEntry, 'day')) {
                        result.results['rabies_vaccine_valid_from.' + idx] = {
                            type: ValidationResultType.Error,
                            message: "Rabies vaccination valid-from date [".concat(validFrom.format('DD/MM/YYYY'), "] is after date of entry [").concat(firstEntry.format('DD/MM/YYYY'), "] for ").concat(pet.name),
                            url: route('team.branch.certificate.vaccination-step', {
                                team: team,
                                branch: branch,
                                certificate: certificate
                            }),
                        };
                    }
                    if (certificate.date_of_issue) {
                        var validFrom_1 = moment(certificatePet.rabies_vaccine_valid_from);
                        var dateOfIssue = moment(certificate.date_of_issue);
                        if (validFrom_1.isAfter(dateOfIssue, 'day')) {
                            result.results['rabies_date_of_issue.' + idx] = {
                                type: ValidationResultType.Error,
                                message: "Rabies vaccination valid-from date [".concat(validFrom_1.format('DD/MM/YYYY'), "] is after date of issue [").concat(dateOfIssue.format('DD/MM/YYYY'), "] for ").concat(pet.name, ". You should not issue an AHC before the rabies vaccine is effective."),
                                url: null,
                            };
                        }
                    }
                }
                if (certificatePet.rabies_vaccination_date === null) {
                    result.results['rabies_vaccination_date.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination date is required for pet ".concat(pet.species, " ").concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
                if (certificatePet.rabies_vaccination_date && certificatePet.transponder_date) {
                    var vaccinationDate = moment(certificatePet.rabies_vaccination_date);
                    var transponderDate = moment(certificatePet.transponder_date);
                    if (transponderDate.isAfter(vaccinationDate, 'day')) {
                        result.results['transponder_date.' + idx] = {
                            type: ValidationResultType.Error,
                            message: "Transponder read/implantation date [".concat(transponderDate.format('DD/MM/YYYY'), "] should be before rabies vaccination date [").concat(vaccinationDate.format('DD/MM/YYYY'), "] for pet ").concat(pet.species, " ").concat(pet.name),
                            url: route('team.branch.certificate.vaccination-step', {
                                team: team,
                                branch: branch,
                                certificate: certificate
                            }),
                        };
                    }
                }
                if (certificatePet.rabies_vaccine_valid_until && certificate.date_of_entry) {
                    var firstEntry = moment(certificate.date_of_entry);
                    var ahcValidUntil = moment(certificate.date_of_entry).add(120, 'days');
                    var validUntil = moment(certificatePet.rabies_vaccine_valid_until);
                    if (validUntil.isBefore(firstEntry, 'day')) {
                        result.results['rabies_valid_until.' + idx] = {
                            type: ValidationResultType.Error,
                            message: "Rabies vaccination expires ".concat(validUntil.format('DD/MM/YYYY'), " before date of first entry ").concat(firstEntry.format('DD/MM/YYYY'), " for pet ").concat(pet.species, " ").concat(pet.name),
                            url: route('team.branch.certificate.vaccination-step', {
                                team: team,
                                branch: branch,
                                certificate: certificate
                            }),
                        };
                    }
                    else if (validUntil.isBefore(ahcValidUntil, 'day')) {
                        result.results['rabies_valid_until.' + idx] = {
                            type: ValidationResultType.Warn,
                            message: "Rabies vaccination expires before the end of the AHC validity period ".concat(ahcValidUntil.format('DD/MM/YYYY'), " for pet ").concat(pet.species, " ").concat(pet.name, ". Please ensure that the client is returning before ").concat(validUntil.format('DD/MM/YYYY'), " and/or consider giving a rabies booster now."),
                            url: null,
                        };
                    }
                }
                else if (!certificatePet.rabies_vaccine_valid_until) {
                    result.results['rabies_vaccine_valid_until.' + idx] = {
                        type: ValidationResultType.Error,
                        message: "Rabies vaccination valid until date is required for ".concat(pet.name),
                        url: route('team.branch.certificate.vaccination-step', {
                            team: team,
                            branch: branch,
                            certificate: certificate
                        }),
                    };
                }
            }
            if (pet.transponder_num && (pet.transponder_num.length != 15 || pet.transponder_num.match(/\D/))) {
                result.results['transponder_num.' + idx] = {
                    type: ValidationResultType.Warn,
                    message: _jsxs("div", { children: ["Transponder number [", pet.transponder_num, "] for ", pet.species, " ", pet.name, " is not the ISO standard ", _jsx("strong", { children: "15 digits" }), ". Are you sure the transponder number is correct?"] }),
                    url: route('team.branch.certificate.pet-step', {
                        team: team,
                        branch: branch,
                        certificate: certificate
                    }),
                };
            }
        });
        this.process_duplicate(certificate, result, duplicate);
        //we need supporting documentation
        if (((_d = certificate.documents) === null || _d === void 0 ? void 0 : _d.length) == 0) {
            result.results['media'] = {
                type: ValidationResultType.Error,
                message: 'Supporting documentation is required. At least rabies vaccination certificates for each pet.',
                url: route('team.branch.certificate.document-step', {
                    team: team,
                    branch: branch,
                    certificate: certificate
                }),
            };
        }
        //date of issue should be within 10 days of travel
        if (certificate.date_of_issue && certificate.date_of_entry) {
            var dateOfIssuePlusTen = moment(certificate.date_of_issue).add(10, 'days');
            var dateOfEntry = moment(certificate.date_of_entry);
            if (dateOfIssuePlusTen.isBefore(dateOfEntry)) {
                result.results['date_of_issue'] = {
                    type: ValidationResultType.Error,
                    message: "An AHC is only valid for 10 days from date of issue and would not be valid on date of entry ".concat(dateOfEntry.format('DD/MM/YYYY')),
                    url: null,
                };
            }
        }
        result.results['stamps'] = {
            type: ValidationResultType.Note,
            message: _jsxs("div", __assign({ className: "prose" }, { children: ["You must stamp and initial the following:", _jsxs("ul", { children: [_jsx("li", { children: "Every paragraph strikeout, except on the Owner/Agent declaration page." }), _jsx("li", { children: "The foot of every page, to include the Owner/Agent\u2019s declaration and supporting documentation." }), _jsx("li", { children: "The wording, 'Certified copy' on supporting documents. " }), _jsx("li", { children: "The Official Veterinarian section." }), "All are indicated with a stamp-sized circle."] }), _jsx("img", { className: "w-32", src: "https://www.ovform.com/storage/stamphere-16386145384Dsdn.png" })] })),
            url: null,
        };
        result.errorCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Error; }).length;
        result.noteCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Note; }).length;
        result.warnCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Warn; }).length;
        return result;
    };
    return CertificateValidator;
}());
export default CertificateValidator;
var CertificateEHCValidator = /** @class */ (function () {
    function CertificateEHCValidator() {
    }
    CertificateEHCValidator.prototype.validate = function (team, branch, certificate, breeds) {
        var route = useRoute(Ziggy);
        var result = {
            errorCount: 0,
            noteCount: 0,
            warnCount: 0,
            results: {},
        };
        if (certificate.ehc_detail.vet === null) {
            // result.results['vet'] = {
            //     type: ValidationResultType.Error,
            //     message: 'Vet details are required',
            //     url: route('team.branch.certificate.ehc-details', {
            //         team: team,
            //         branch: branch,
            //         certificate: certificate
            //     }),
            // }
        }
        var duplicate = {};
        // we need supporting documentation
        // if (certificate.documents?.length == 0) {
        //     result.results['media'] = {
        //         type: ValidationResultType.Error,
        //         message: 'Supporting documentation is required. At least rabies vaccination certificates for each pet.',
        //         url: route('team.branch.certificate.ehc-details', {
        //             team: team,
        //             branch: branch,
        //             certificate: certificate
        //         }),
        //     }
        // }
        result.results['stamps'] = {
            type: ValidationResultType.Note,
            message: _jsxs("div", __assign({ className: "prose" }, { children: ["You must stamp and initial the following:", _jsxs("ul", { children: [_jsx("li", { children: "Every paragraph strikeout, except on the Owner/Agent declaration page." }), _jsx("li", { children: "The foot of every page, to include the Owner/Agent\u2019s declaration and supporting documentation." }), _jsx("li", { children: "The wording, 'Certified copy' on supporting documents. " }), _jsx("li", { children: "The Official Veterinarian section." }), "All are indicated with a stamp-sized circle."] }), _jsx("img", { className: "w-32", src: "https://www.ovform.com/storage/stamphere-16386145384Dsdn.png" })] })),
            url: null,
        };
        result.errorCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Error; }).length;
        result.noteCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Note; }).length;
        result.warnCount = Object.values(result.results).filter(function (item) { return item.type === ValidationResultType.Warn; }).length;
        return result;
    };
    return CertificateEHCValidator;
}());
export { CertificateEHCValidator };
